<div class="wrapper">
    <button
        class="switcher ms-xs-0 ps-xs-0"
        [disabled]="!appliedFiltersCount"
        (click)="toggleFiltersDisplay()"
    >
        Filters
        <span class="filters-count">({{ appliedFiltersCount }})</span>
        <app-icon
            type="Arrow-down"
            class="arrow-down"
            [ngClass]="{ 'arrow-up': shouldDisplayAppliedFilters }"
        ></app-icon>
    </button>
    <button class="select-filters" (click)="openMobileFilters()">
        Select filters
        <app-icon [type]="'Pencil'"></app-icon>
    </button>
    <app-applied-filters
        [shouldBeDisplayed]="shouldDisplayAppliedFilters"
        [searchInfo]="searchInfo"
    ></app-applied-filters>
</div>
